import paymentTypes from '../types/payment';

const initialStore = {
    paymentModalOpen: false,
    paymentStepsOpen: false,
    paymentResult: null,
    paymentError: '',
    paymentErrorCount: 0,
    paymentConfirmationId: null,
    stepFirstDone: true,
    stepSecondDone: false,
    stepThirdDone: false,
    stepFourthDone: false,
    user: null,
    paymentType: '',
    paymentAmount: '',
    paymentCustomAmount: '',
    paymentMethod: '',
    paymentCardNumber: '',
    paymentCardNumberSpaced: '',
    paymentCardNumberError: '',
    paymentMonth: '',
    paymentMonthError: '',
    paymentYear: '',
    paymentYearError: '',
    paymentCvv: '',
    paymentCvvError: '',
    paymentFirstName: '',
    paymentFirstNameError: '',
    paymentAddress: '',
    paymentAddressError: '',
    paymentCity: '',
    paymentCityError: '',
    paymentState: '',
    paymentStateError: '',
    paymentZipCode: '',
    paymentZipCodeError: '',
    paymentBankAccount: '',
    paymentBankAccountError: '',
    paymentBankAccountName: '',
    paymentBankAccountNameError: '',
    paymentRoutingNumber: '',
    paymentRoutingNumberError: '',
    paymentAccountType: '',
    paymentAccountTypeError: '',
    confirmType: '',
    confirmEmail: '',
    confirmCustomEmail: '',
    formAccountNumber: '',
    formZipCode: '',
    formError: '',
    isLoading: false,
    isAccountFormLoading: false,
    monthList: [
        {
            label: '01-Jan',
            value: '01'
        },
        {
            label: '02-Feb',
            value: '02'
        },
        {
            label: '03-Mar',
            value: '03'
        },
        {
            label: '04-Apr',
            value: '04'
        },
        {
            label: '05-May',
            value: '05'
        },
        {
            label: '06-Jun',
            value: '06'
        },
        {
            label: '07-Jul',
            value: '07'
        },
        {
            label: '08-Aug',
            value: '08'
        },
        {
            label: '09-Sep',
            value: '09'
        },
        {
            label: '10-Oct',
            value: '10'
        },
        {
            label: '11-Nov',
            value: '11'
        },
        {
            label: '12-Dec',
            value: '12'
        },
    ],
    statesList: [
        {
            label: 'Alabama',
            value: 'AL'
        },
        {
            label: 'Alaska',
            value: 'AK'
        },
        {
            label: 'Arizona',
            value: 'AZ'
        },
        {
            label: 'Arkansas',
            value: 'AR'
        },
        {
            label: 'California',
            value: 'CA'
        },
        {
            label: 'Colorado',
            value: 'CO'
        },
        {
            label: 'Connecticut',
            value: 'CT'
        },
        {
            label: 'Delaware',
            value: 'DE'
        },
        {
            label: 'Florida',
            value: 'FL'
        },
        {
            label: 'Georgia',
            value: 'GA'
        },
        {
            label: 'Hawaii',
            value: 'HI'
        },
        {
            label: 'Idaho',
            value: 'ID'
        },
        {
            label: 'Illinois',
            value: 'IL'
        },
        {
            label: 'Indiana',
            value: 'IN'
        },
        {
            label: 'Iowa',
            value: 'IA'
        },
        {
            label: 'Kansas',
            value: 'KS'
        },
        {
            label: 'Kentucky',
            value: 'KY'
        },
        {
            label: 'Louisiana',
            value: 'LA'
        },
        {
            label: 'Maine',
            value: 'ME'
        },
        {
            label: 'Maryland',
            value: 'MD'
        },
        {
            label: 'Massachusetts',
            value: 'MA'
        },
        {
            label: 'Michigan',
            value: 'MI'
        },
        {
            label: 'Minnesota',
            value: 'MN'
        },
        {
            label: 'Mississippi',
            value: 'MS'
        },
        {
            label: 'Missouri',
            value: 'MO'
        },
        {
            label: 'Montana',
            value: 'MT'
        },
        {
            label: 'Nebraska',
            value: 'NE'
        },
        {
            label: 'Nevada',
            value: 'NV'
        },
        {
            label: 'New Hampshire',
            value: 'NH'
        },
        {
            label: 'New Jersey',
            value: 'NJ'
        },
        {
            label: 'New Mexico',
            value: 'NM'
        },
        {
            label: 'New York',
            value: 'NY'
        },
        {
            label: 'North Carolina',
            value: 'NC'
        },
        {
            label: 'North Dakota',
            value: 'ND'
        },
        {
            label: 'Ohio',
            value: 'OH'
        },
        {
            label: 'Oklahoma',
            value: 'OK'
        },
        {
            label: 'Oregon',
            value: 'OR'
        },
        {
            label: 'Pennsylvania',
            value: 'PA'
        },
        {
            label: 'Rhode Island',
            value: 'RI'
        },
        {
            label: 'South Carolina',
            value: 'SC'
        },
        {
            label: 'South Dakota',
            value: 'SD'
        },
        {
            label: 'Tennessee',
            value: 'TN'
        },
        {
            label: 'Texas',
            value: 'TX'
        },
        {
            label: 'Utah',
            value: 'UT'
        },
        {
            label: 'Vermont',
            value: 'VT'
        },
        {
            label: 'Virginia',
            value: 'VA'
        },
        {
            label: 'Washington',
            value: 'WA'
        },
        {
            label: 'West Virginia',
            value: 'WV'
        },
        {
            label: 'Wisconsin',
            value: 'WI'
        },
        {
            label: 'Wyoming',
            value: 'WY'
        },
    ],
    accountTypesList: [
        {
            label: 'Checking',
            value: 'checking'
        },
        {
            label: 'Savings',
            value: 'saving'
        },
    ],
};

const paymentStore = (state = initialStore, action) => {
    switch (action.type) {
        case paymentTypes.SET_PAYMENT_MODAL_OPEN:
            return {
                ...state,
                paymentModalOpen: action.boolean,
            };
        case paymentTypes.SET_PAYMENT_STEPS_OPEN:
            return {
                ...state,
                paymentStepsOpen: action.boolean,
            };
        case paymentTypes.SET_PAYMENT_RESULT:
            return {
                ...state,
                paymentResult: action.string,
            };
        case paymentTypes.SET_PAYMENT_ERROR:
            return {
                ...state,
                paymentError: action.payload,
            };        
        case paymentTypes.SET_PAYMENT_ERROR_COUNT:
            return {
                ...state,
                paymentErrorCount: action.payload === 0 ? 0 : state.paymentErrorCount + 1,
            };        
        case paymentTypes.SET_PAYMENT_CONFIRMATION_ID:
            return {
                ...state,
                paymentConfirmationId: action.payload,
            };
        case paymentTypes.SET_STEP_FIRST_DONE:
            return {
                ...state,
                stepFirstDone: action.boolean,
            };
        case paymentTypes.SET_STEP_SECOND_DONE:
            return {
                ...state,
                stepSecondDone: action.boolean,
            };
        case paymentTypes.SET_STEP_THIRD_DONE:
            return {
                ...state,
                stepThirdDone: action.boolean,
            };
        case paymentTypes.SET_STEP_FOURTH_DONE:
            return {
                ...state,
                stepFourthDone: action.boolean,
            };
        case paymentTypes.SET_USER:
            return {
                ...state,
                user: action.object,
            };
        case paymentTypes.SET_PAYMENT_TYPE:
            return {
                ...state,
                paymentType: action.string,
            };
        case paymentTypes.SET_PAYMENT_AMOUNT:
            return {
                ...state,
                paymentAmount: action.string,
            };
        case paymentTypes.SET_PAYMENT_CUSTOM_AMOUNT:
            return {
                ...state,
                paymentCustomAmount: action.string,
            };
        case paymentTypes.SET_PAYMENT_METHOD:
            return {
                ...state,
                paymentMethod: action.string,
            };
        case paymentTypes.SET_PAYMENT_CARD_NUMBER:
            return {
                ...state,
                paymentCardNumber: action.string,
            };
        case paymentTypes.SET_PAYMENT_CARD_NUMBER_SPACED:
            return {
                ...state,
                paymentCardNumberSpaced: action.string,
            };
        case paymentTypes.SET_PAYMENT_CARD_NUMBER_ERROR:
            return {
                ...state,
                paymentCardNumberError: action.string,
            };
        case paymentTypes.SET_PAYMENT_MONTH:
            return {
                ...state,
                paymentMonth: action.string,
            };
        case paymentTypes.SET_PAYMENT_MONTH_ERROR:
            return {
                ...state,
                paymentMonthError: action.string,
            };
        case paymentTypes.SET_PAYMENT_YEAR:
            return {
                ...state,
                paymentYear: action.string,
            };
        case paymentTypes.SET_PAYMENT_YEAR_ERROR:
            return {
                ...state,
                paymentYearError: action.string,
            };
        case paymentTypes.SET_PAYMENT_CVV:
            return {
                ...state,
                paymentCvv: action.string,
            };
        case paymentTypes.SET_PAYMENT_CVV_ERROR:
            return {
                ...state,
                paymentCvvError: action.string,
            };
        case paymentTypes.SET_PAYMENT_FIRST_NAME:
            return {
                ...state,
                paymentFirstName: action.string,
            };
        case paymentTypes.SET_PAYMENT_FIRST_NAME_ERROR:
            return {
                ...state,
                paymentFirstNameError: action.string,
            };
        case paymentTypes.SET_PAYMENT_ADDRESS:
            return {
                ...state,
                paymentAddress: action.string,
            };
        case paymentTypes.SET_PAYMENT_ADDRESS_ERROR:
            return {
                ...state,
                paymentAddressError: action.string,
            };
        case paymentTypes.SET_PAYMENT_STATE:
            return {
                ...state,
                paymentState: action.string,
            };
        case paymentTypes.SET_PAYMENT_STATE_ERROR:
            return {
                ...state,
                paymentStateError: action.string,
            };
        case paymentTypes.SET_PAYMENT_CITY:
            return {
                ...state,
                paymentCity: action.string,
            };
        case paymentTypes.SET_PAYMENT_CITY_ERROR:
            return {
                ...state,
                paymentCityError: action.string,
            };
        case paymentTypes.SET_PAYMENT_ZIP_CODE:
            return {
                ...state,
                paymentZipCode: action.string,
            };
        case paymentTypes.SET_PAYMENT_ZIP_CODE_ERROR:
            return {
                ...state,
                paymentZipCodeError: action.string,
            };
        case paymentTypes.SET_PAYMENT_BANK_ACCOUNT:
            return {
                ...state,
                paymentBankAccount: action.string,
            };
        case paymentTypes.SET_PAYMENT_BANK_ACCOUNT_ERROR:
            return {
                ...state,
                paymentBankAccountError: action.string,
            };
        case paymentTypes.SET_PAYMENT_BANK_ACCOUNT_NAME:
            return {
                ...state,
                paymentBankAccountName: action.string,
            };
        case paymentTypes.SET_PAYMENT_BANK_ACCOUNT_NAME_ERROR:
            return {
                ...state,
                paymentBankAccountNameError: action.string,
            }
        case paymentTypes.SET_PAYMENT_ROUTING_NUMBER:
            return {
                ...state,
                paymentRoutingNumber: action.string,
            };
        case paymentTypes.SET_PAYMENT_ROUTING_NUMBER_ERROR:
            return {
                ...state,
                paymentRoutingNumberError: action.string,
            };
        case paymentTypes.SET_PAYMENT_ACCOUNT_TYPE:
            return {
                ...state,
                paymentAccountType: action.string,
            };
        case paymentTypes.SET_PAYMENT_ACCOUNT_TYPE_ERROR:
            return {
                ...state,
                paymentAccountTypeError: action.string,
            };
        case paymentTypes.SET_CONFIRM_TYPE:
            return {
                ...state,
                confirmType: action.string,
            };
        case paymentTypes.SET_CONFIRM_EMAIL:
            return {
                ...state,
                confirmEmail: action.string,
            };
        case paymentTypes.SET_CONFIRM_CUSTOM_EMAIL:
            return {
                ...state,
                confirmCustomEmail: action.string,
            };
        case paymentTypes.SET_FORM_ACCOUNT_NUMBER:
            return {
                ...state,
                formAccountNumber: action.string,
            };
        case paymentTypes.SET_FORM_ZIP_CODE:
            return {
                ...state,
                formZipCode: action.string,
            };
        case paymentTypes.SET_FORM_ERROR:
            return {
                ...state,
                formError: action.string,
            };
        case paymentTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.boolean,
            };
        case paymentTypes.SET_ACCOUNT_FORM_LOADING:
            return {
                ...state,
                isAccountFormLoading: action.boolean,
            };
        default:
            return state;
    }
};

export default paymentStore;
